import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { SHIFTS as DEFAULT_SHIFTS, SHIFT_COLORS, SHIFT_ORDER } from "../lib/schedule";

const ShiftsContext = createContext(null);

export function ShiftsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const reload = useCallback(async () => {
    try {
      const res = await api.get("/shift-settings");
      setSettings(res.data.shifts);
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const shifts = SHIFT_ORDER.map((key) => {
    const base = DEFAULT_SHIFTS.find((x) => x.key === key);
    const s = settings?.[key] || {};
    return {
      key,
      label: s.label || base.label,
      time: s.time || base.time,
      sub: s.sub ?? base.sub,
      badge: SHIFT_COLORS[key].badge,
      dot: SHIFT_COLORS[key].dot,
    };
  });

  return <ShiftsContext.Provider value={{ shifts, settings, reload }}>{children}</ShiftsContext.Provider>;
}

export const useShifts = () => useContext(ShiftsContext);
